function ready(callbackFunc) {
  if (document.readyState !== 'loading') {
    // Document is already ready, call the callback directly
    callbackFunc();
  } else if (document.addEventListener) {
    // All modern browsers to register DOMContentLoaded
    document.addEventListener('DOMContentLoaded', callbackFunc);
  } else {
    // Old IE browsers
    document.attachEvent('onreadystatechange', function () {
      if (document.readyState === 'complete') {
        callbackFunc();
      }
    });
  }
}


  var galleryThumbs = new Swiper('.gallery-thumbs', {
    slidesPerView: 3,
    spaceBetween: 10,
    loop: false,
    direction: 'horizontal',
    navigation: {
      nextEl: '.swiper-button-next-thumb',
      prevEl: '.swiper-button-prev-thumb'
    },
    breakpoints: {
       1080: {
        direction: 'vertical'
      }
    }
  });

  galleryThumbs.on("realIndexChange",e => {

    if(!e.isEnd && !e.isBeginning){
      const arrowLeft = document.querySelector(".swiper-button-prev-thumb svg");
      const arrowRight = document.querySelector(".swiper-button-next-thumb svg");
      arrowLeft.classList.remove("hidden");
      arrowRight.classList.remove("hidden");
    }

  });

  galleryThumbs.on("reachEnd",() => {
    const arrowRight = document.querySelector(".swiper-button-next-thumb svg");
    const arrowLeft = document.querySelector(".swiper-button-prev-thumb svg");
    arrowRight.classList.add("hidden");
    arrowLeft.classList.remove("hidden");
  });

  galleryThumbs.on("reachBeginning",() => {
    const arrowLeft = document.querySelector(".swiper-button-prev-thumb svg");
    const arrowRight = document.querySelector(".swiper-button-next-thumb svg");
    arrowLeft.classList.add("hidden");
    arrowRight.classList.remove("hidden");
  });

  var galleryTop = new Swiper('.gallery-top', {
    slidesPerView: 1,
    loop: false,
    spaceBetween: 0,
    pagination: {
      el: ".swiper-pagination"
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    }
  });

  galleryTop.on("slideChange", e => {
    
    const slide = e.slides[e.activeIndex];
    const id = slide.dataset.variantId;
    const actualVariant = window.variants.filter(variant => variant.id == id );
    const actualColor = actualVariant[0].option1;

    const selectColor = document.querySelector(".select-color");
    const options = selectColor.querySelectorAll("option");

    options.forEach( option => {
      if(option.value == actualColor) {
        option.selected = true;
      }
    })

    const thumbsSlider = document.querySelector(".gallery-thumbs");
    const thumbsSlider_slides = thumbsSlider.querySelectorAll(".swiper-slide");

    thumbsSlider_slides.forEach(slide => {

      if(slide.dataset.variantId == id){

        const indexText = slide.getAttribute("aria-label");
        const index = Number(indexText.split("/")[0].trim()) - 1;
        galleryThumbs.slideTo(index,1000,false)

      }

    })

    const sectionId = galleryTop.$el[0].dataset.sectionId;
    const actualColorForm = document.querySelector(`#Option-${sectionId}-0`).value;
    const actualSizeForm = document.querySelector(`#Option-${sectionId}-1`);
    let exist_variant;
    const addButton = document.getElementById(`product-form-${sectionId}`)?.querySelector('[name="add"]');    

    if(actualSizeForm){
      exist_variant = window.variants.find( variant => variant.option1 == actualColorForm && variant.option2 == actualSizeForm.value)
    }else{
      exist_variant = window.variants.find( variant => variant.option1 == actualColorForm)
    }

    if(!exist_variant){
      addButton.textContent = window.variantStrings.unavailable;
      addButton.setAttribute('disabled', true);
      document.getElementById(`price-${sectionId}`)?.classList.add('hidden');
    }else{
      document.getElementById(`price-${sectionId}`)?.classList.remove('hidden');
      addButton.removeAttribute('disabled');
      addButton.textContent = window.variantStrings.addToCart;
    }
    
  });


  let gallerySlides = document.querySelectorAll('.gallery-thumbs .swiper-slide')
  gallerySlides.forEach(element => {
    
    element.addEventListener('click',function(e) {
      e.preventDefault();
      e.stopPropagation();
      let indexClicked = Array.from(this.parentNode.children).indexOf(this)
      console.log(indexClicked);
      const slider_top_wrapper_count = document.querySelector(".gallery-top .swiper-wrapper").children.length;
      const className_to_find = `.gallery-top .swiper-slide[aria-label="${indexClicked+1} / ${slider_top_wrapper_count}"]`
      console.log(className_to_find);
      let elementSlide = document.querySelector(className_to_find);
      console.log(elementSlide);
      let indexSlide =Array.from(elementSlide.parentNode.children).indexOf(elementSlide)
      galleryTop.slideTo(indexSlide, 1000, false)
      e.preventDefault();
      e.stopPropagation();
    })

  });
